import { useQuery } from '@tanstack/react-query';

import type { Identity } from '~/interfaces/identity';

export const identitiesKeys = {
  all: ['identities'] as const,
  bySubscriber: (subscriberId: string) => ['identities', subscriberId] as const,
};

const fetchIdentities = async (subscriberId: string): Promise<Identity[]> => {
  const response = await fetch(`/subscribe/${subscriberId}/identities`);
  if (!response.ok) throw new Error('Failed to fetch identities');
  return response.json();
};

const useIdentities = (subscriberId: string, enabled: boolean) => {
  const { data, isLoading } = useQuery({
    queryKey: identitiesKeys.bySubscriber(subscriberId),
    queryFn: () => fetchIdentities(subscriberId),
    enabled: enabled && !!subscriberId,
    staleTime: Number.POSITIVE_INFINITY,
    refetchOnWindowFocus: false,
  });

  return {
    isLoading,
    identities: data ?? [],
  };
};

export default useIdentities;
